<template>
    <div>
        <v-layout
            row
            wrap
            class="prospective-member__list-item"
            v-if="localProspect">
            <v-flex
                xs12
                sm5
                md5>
                <v-flex class="prospective-member__list-item__user">
                    <v-list two-line>
                        <v-list-tile>
                            <v-list-tile-avatar>
                                <img :src="localProspect.profileImageUrl" :onerror="imageErrorFallback(localProspect.fallbackProfileImageUrl)" :data-qe-id="`lead_profile_image_${localProspect.id}`">
                            </v-list-tile-avatar>
                            <v-list-tile-content>
                                <v-list-tile-title :data-qe-id="`lead_name_${localProspect.id}`">{{userName()}}</v-list-tile-title>
                                <v-list-tile-sub-title :data-qe-id="`lead_chaptername_${localProspect.id}`">{{localProspect.chapterName}}</v-list-tile-sub-title>
                            </v-list-tile-content>
                        </v-list-tile>
                    </v-list>
                </v-flex>
            </v-flex>
            <v-flex
                class="prospective-member__list-item__view"
                xs12
                sm4
                md4
                text-sm-center>
                <v-flex
                    tag="span"
                    v-if="!isWaiverVisible"
                    :data-qe-id="`chapteradmin_view_waiver_${localProspect.id}`">{{chapterWaiverConstants.VIEW_WAIVER}}</v-flex>
                <v-flex
                    tag="span"
                    v-if="isWaiverVisible && reportVisible"
                    :data-qe-id="`chapteradmin_close_waiver_${localProspect.id}`">{{chapterWaiverConstants.CLOSE_WAIVER}}</v-flex>
                <i class="fas fa-chevron-down" data-qe-id="btn_view_waiver" v-if="!isWaiverVisible" @click="toggleWaiver(localProspect.id)"></i>
                <i class="fas fa-chevron-up" data-qe-id="btn_close_waiver" v-if="isWaiverVisible && reportVisible" @click="toggleWaiver(localProspect.id)"></i>
            </v-flex>
            <v-flex
                xs12
                sm3
                md3
                text-sm-right
                v-if="showSubmitButton">
                <span class="prospective-member__list-item__sent-info" v-if="disableSubmitButton(localProspect)">
                    <em :data-qe-id="`sent_on_date_label_${localProspect.id}`">{{chapterWaiverConstants.REQUESTED_ON}}</em>
                    <em :data-qe-id="`sent_on_date_${localProspect.id}`">{{getRequestedDate(localProspect)}}</em>
                </span>
                <v-btn
                    class="primary_btn small"
                    data-qe-id="btn_submit_waiver"
                    :disabled="!valid || disableSubmitButton(localProspect)"
                    @click="submitWaiver(waiverDetails)">{{appCommonConstants.SUBMIT}}</v-btn>
                <span class="prospective-member__list-item__sent-info" v-if="isSave" :data-qe-id="`success_${waiverDetails.id}`">
                    <em class="success-text">{{requestedMessage}}</em>
                </span>
                <span class="prospective-member__list-item__sent-info" v-if="isError" :data-qe-id="`error_${waiverDetails.id}`">
                    <em class="error-color">{{errorMessage}}</em>
                </span>
            </v-flex>
            <v-flex
                xs12
                sm3
                md3
                text-sm-right
                v-else
                class="prospective-member__list-item__status"
                data-qe-id="waiver_status">
                <span class="prospective-member__list-item__sent-info" v-if="localProspect.waiverDecisionDate">
                    <em :data-qe-id="`decision_date_label_${localProspect.id}`">{{ localProspect.waiverFlowStatus }} {{chapterWaiverConstants.ON}}</em>
                    <em :data-qe-id="`decision_date_${localProspect.id}`">{{getRequestedDate(localProspect)}}</em>
                </span>
                <span :class="setColor(localProspect.waiverStatus)">{{localProspect.waiverStatus}}</span>
            </v-flex>
            <v-flex
                class="view-wavier active"
                xs12
                v-if="isWaiverVisible">
                <status-bar :action="submitWaiverDetails"></status-bar>
                <v-flex
                    class="prospective-member__loading"
                    v-if="getInProgress"
                    justify-center
                    text-xs-center>
                    <v-progress-circular indeterminate color="grey"></v-progress-circular>
                </v-flex>
                <v-flex
                    px-5
                    py-3
                    v-else-if="waiverDetails"
                    class="view-wavier__block">
                    <v-form
                        lazy-validation
                        :ref="`waiverDetails-${waiverDetails.id}`"
                        v-model="valid">
                        <v-flex class="form-control">
                            <v-flex tag="span">{{waiverFormConstants.TYPE_OF_WAIVER}}
                                <v-flex tag="small" class="error-color">{{waiverFormConstants.MANDATORY}}</v-flex>
                            </v-flex>
                            <v-flex font-italic tag="small">{{waiverFormConstants.TYPE_OF_WAIVER_WATER_MARK}}</v-flex>
                            <v-autocomplete
                                attach
                                :items="waiverTypes"
                                item-text="type"
                                item-value="type"
                                :append-icon="reportVisible ? 'arrow_drop_down': '' "
                                v-model="waiverDetails.typeOfWaiver"
                                data-qe-id="select_form_waiver_typeOfWaiver"
                                :readonly="disableWaiverDetails(waiverDetails)"
                                :rules="validationRules.typeOfWaiverRule"></v-autocomplete>
                        </v-flex>
                        <v-flex class="form-control">
                            <v-flex tag="span">{{waiverFormConstants.AGE}}
                                <v-flex tag="small" class="error-color">{{waiverFormConstants.MANDATORY}}</v-flex>
                            </v-flex>
                            <v-text-field
                                :rules="validationRules.ageRule"
                                solo
                                v-model="waiverDetails.age"
                                readonly
                                data-qe-id="txt_form_waiver_age"></v-text-field>
                        </v-flex>
                        <v-flex class="form-control">
                            <v-flex tag="span">{{waiverFormConstants.DOB}}
                                <v-flex tag="small" class="error-color">{{waiverFormConstants.MANDATORY}}</v-flex>
                            </v-flex>
                            <v-flex>
                                <v-menu
                                    :close-on-content-click="false"
                                    v-model="menu"
                                    :nudge-right="40"
                                    lazy
                                    transition="scale-transition"
                                    offset-y
                                    :disabled="disableWaiverDetails(waiverDetails)"
                                    full-width
                                    data-qe-id="menu_waiver_DOB"
                                    min-width="290px"
                                    max-width="290px">
                                    <v-text-field
                                        class="date-of-birth"
                                        slot="activator"
                                        id="birth_date_input_waiver"
                                        data-qe-id="txt_waiver_DOB"
                                        v-model="computedDateFormatted"
                                        prepend-inner-icon="event"
                                        :disabled="disableWaiverDetails(waiverDetails)"
                                        required
                                        solo
                                        readonly></v-text-field>
                                    <v-date-picker
                                        ref="picker"
                                        data-qe-id="DOB_date_picker"
                                        @input="datePickerAction()"
                                        v-model="birthDateISOString"
                                        :readonly="disableWaiverDetails(waiverDetails)"
                                        :max="new Date().toISOString().substr(0, 10)"
                                        min="1900-01-01"></v-date-picker>
                                </v-menu>
                            </v-flex>
                        </v-flex>
                        <v-flex class="form-control">
                            <v-flex tag="span">{{waiverFormConstants.COMPANY_NAME}}
                                <v-flex tag="small" class="error-color">{{waiverFormConstants.MANDATORY}}</v-flex>
                            </v-flex>
                            <v-text-field
                                solo
                                :rules="validationRules.companyNameRule"
                                v-model="waiverDetails.companyName"
                                :readonly="disableWaiverDetails(waiverDetails)"
                                data-qe-id="txt_form_waiver_companyname"></v-text-field>
                        </v-flex>
                        <v-flex class="form-control">
                            <v-flex tag="span">{{waiverFormConstants.WHO_DO_YOU_REPORT_TO}}
                                <v-flex tag="small" class="error-color">{{waiverFormConstants.MANDATORY}}</v-flex>
                            </v-flex>
                            <v-text-field
                                solo
                                :rules="validationRules.WhoDoYouReportToRule"
                                v-model="waiverDetails.whoDoYouReportTo"
                                :readonly="disableWaiverDetails(waiverDetails)"
                                data-qe-id="txt_who_do_you_report_to"></v-text-field>
                        </v-flex>
                        <v-flex class="form-control link">
                            <v-flex tag="span">{{waiverFormConstants.COMPANY_WEBSITE}}
                                <v-flex tag="small" class="error-color">{{waiverFormConstants.MANDATORY}}</v-flex>
                            </v-flex>
                            <v-text-field
                                solo
                                :rules="validationRules.websiteUrlRule"
                                v-model="waiverDetails.companyWebsite"
                                :readonly="disableWaiverDetails(waiverDetails)"
                                data-qe-id="txt_form_waiver_companywebsite"></v-text-field>
                        </v-flex>
                        <v-flex class="form-control">
                            <v-flex tag="span">{{waiverFormConstants.TITLE}}
                                <v-flex tag="small" class="error-color">{{waiverFormConstants.MANDATORY}}</v-flex>
                            </v-flex>
                            <v-autocomplete
                                attach
                                :items="titleTypes"
                                item-text="type"
                                item-value="type"
                                :append-icon="reportVisible ? 'arrow_drop_down': '' "
                                v-model="waiverDetails.title"
                                data-qe-id="select_form_waiver_title"
                                :readonly="disableWaiverDetails(waiverDetails)"
                                :rules="validationRules.titleRule"
                                @click="selectOtherTitle(waiverDetails)"></v-autocomplete>
                        </v-flex>
                        <v-flex class="form-control" v-if="waiverDetails.title && waiverDetails.title.toLowerCase() === waiverFormConstants.OTHER">
                            <v-flex tag="span">{{waiverFormConstants.TITLE_OTHER}}
                                <v-flex tag="small" class="error-color">{{waiverFormConstants.MANDATORY}}</v-flex>
                            </v-flex>
                            <v-text-field
                                solo
                                :rules="validationRules.titleOtherRule"
                                v-model="waiverDetails.titleOther"
                                :readonly="disableWaiverDetails(waiverDetails)"
                                data-qe-id="txt_form_waiver_title_other"></v-text-field>
                        </v-flex>
                        <v-flex class="form-control">
                            <v-flex tag="span">{{waiverFormConstants.NO_OF_EMPLOYEES}}
                                <v-flex tag="small" class="error-color">{{waiverFormConstants.MANDATORY}}</v-flex>
                            </v-flex>
                            <v-flex font-italic tag="small">{{waiverFormConstants.NO_OF_EMPLOYEES_WATER_MARK}}</v-flex>
                            <v-text-field
                                solo
                                :rules="validationRules.employeesRule"
                                v-model="waiverDetails.numberOfEmployees"
                                :readonly="disableWaiverDetails(waiverDetails)"
                                data-qe-id="txt_form_waiver_noofemployees"></v-text-field>
                        </v-flex>
                        <v-flex class="form-control" v-if="waiverDetails.numberOfEmployees < 50">
                            <v-flex tag="span">{{waiverFormConstants.TOTAL_EMPLOYEE_COMP}}
                                <v-flex tag="small" class="error-color">{{waiverFormConstants.MANDATORY}}</v-flex>
                            </v-flex>
                            <v-text-field
                                solo
                                :rules="validationRules.totalEmployeeRule"
                                v-model="waiverDetails.totalCompensation"
                                :readonly="disableWaiverDetails(waiverDetails)"
                                :maxlength="chapterWaiverConstants.MAX_LENGTH"
                                @focus="waiverDetails.totalCompensation = removeCommas(waiverDetails.totalCompensation)"
                                @blur="waiverDetails.totalCompensation = getCommaSeparatedValue(waiverDetails.totalCompensation)"
                                data-qe-id="txt_form_waiver_totalcompensation"></v-text-field>
                        </v-flex>
                        <v-flex class="form-control">
                            <v-flex tag="span">{{waiverFormConstants.CORP_TYPE}}
                                <v-flex tag="small" class="error-color">{{waiverFormConstants.MANDATORY}}</v-flex>
                            </v-flex>
                            <v-autocomplete
                                attach
                                :items="corporationTypes"
                                item-text="corporationType"
                                item-value="corporationType"
                                :append-icon="reportVisible ? 'arrow_drop_down': '' "
                                v-model="waiverDetails.corporationType"
                                data-qe-id="select_form_waiver_corptype"
                                :readonly="disableWaiverDetails(waiverDetails)"
                                :rules="validationRules.corporationTypeRule"></v-autocomplete>
                        </v-flex>
                        <v-flex class="form-control">
                            <v-flex tag="span">{{waiverFormConstants.DOLLAR_VALUE}}
                                <v-flex tag="small" class="error-color">{{waiverFormConstants.MANDATORY}}</v-flex>
                            </v-flex>
                            <v-text-field
                                solo
                                v-model="waiverDetails.dollarVolume"
                                :readonly="disableWaiverDetails(waiverDetails)"
                                :rules="validationRules.dollarRule"
                                :maxlength="chapterWaiverConstants.MAX_LENGTH"
                                @focus="waiverDetails.dollarVolume = removeCommas(waiverDetails.dollarVolume)"
                                @blur="waiverDetails.dollarVolume = getCommaSeparatedValue(waiverDetails.dollarVolume)"
                                data-qe-id="txt_form_waiver_dollarVolume"></v-text-field>
                        </v-flex>
                        <v-flex class="form-control">
                            <v-flex tag="span" class="d-flex">{{waiverFormConstants.ENTERPRISE_VALUE}}
                                <v-flex xs1 pl-1>
                                    <v-tooltip slot="append" right>
                                        <i class="fas fa-info-circle" slot="activator"></i>
                                        <span>{{waiverFormConstants.ENTERPRISE_VALUE_INFO}}</span>
                                    </v-tooltip>
                                </v-flex>
                            </v-flex>
                            <v-text-field
                                :rules="validationRules.enterpriseValueRule"
                                solo
                                v-model="waiverDetails.enterpriseValue"
                                :readonly="disableWaiverDetails(waiverDetails)"
                                :maxlength="chapterWaiverConstants.MAX_LENGTH"
                                @focus="waiverDetails.enterpriseValue = removeCommas(waiverDetails.enterpriseValue)"
                                @blur="waiverDetails.enterpriseValue = getCommaSeparatedValue(waiverDetails.enterpriseValue)"
                                data-qe-id="txt_form_waiver_enterpriseValue"></v-text-field>
                        </v-flex>
                        <v-flex class="form-control">
                            <v-flex tag="span">{{waiverFormConstants.NO_OF_MEMBERS_IN_CHAPTER}}
                                <v-flex tag="small" class="error-color">{{waiverFormConstants.MANDATORY}}</v-flex>
                            </v-flex>
                            <v-text-field
                                solo
                                v-model="waiverDetails.chapterMembersCount"
                                :readonly="disableWaiverDetails(waiverDetails)"
                                data-qe-id="txt_form_waiver_membercount"
                                :rules="validationRules.numericRule"></v-text-field>
                        </v-flex>
                        <v-flex tag="h1">
                            {{waiverFormConstants.FORM_TEXT1}}
                            <v-flex tag="span" color="red">{{waiverFormConstants.FORM_TEXT2}}</v-flex> {{waiverFormConstants.FORM_TEXT3}}
                        </v-flex>
                        <v-flex tag="h2">{{waiverFormConstants.FORM_WARNING}}</v-flex>
                        <v-flex v-if="waiverQuestions && waiverQuestions.length > 0 && waiverDetails.waiverAnswerList">
                            <v-flex class="form-control">
                                <v-flex tag="span">{{waiverQuestions[0].question}}
                                    <v-flex tag="small" class="error-color">{{waiverFormConstants.MANDATORY}}</v-flex>
                                </v-flex>
                                <v-textarea
                                    v-if="!isPrintForm"
                                    auto-grow
                                    solo
                                    data-qe-id="txt_form_waiver_q1"
                                    :readonly="disableWaiverDetails(waiverDetails)"
                                    :rules="validationRules.question_Rule"
                                    v-model="waiverDetails.waiverAnswerList.find(x => x.questionId === waiverQuestions[0].id).answer"></v-textarea>
                                    <v-flex class="answer-text" v-if="isPrintForm"> {{waiverDetails.waiverAnswerList.find(x => x.questionId === waiverQuestions[0].id).answer}}
                                    </v-flex>
                            </v-flex>
                            <v-flex class="form-control">
                                <v-flex v-if="waiverQuestions[1].question" tag="span">{{waiverQuestions[1].question.part1}} <em>{{waiverQuestions[1].question.part2}}</em>
                                    {{waiverQuestions[1].question.part3}}
                                    <v-flex tag="small" class="error-color">{{waiverFormConstants.MANDATORY}}</v-flex>
                                </v-flex>
                                <v-textarea
                                    v-if="!isPrintForm"
                                    auto-grow
                                    solo
                                    data-qe-id="txt_form_waiver_q2"
                                    :readonly="disableWaiverDetails(waiverDetails)"
                                    :rules="validationRules.question_Rule"
                                    v-model="waiverDetails.waiverAnswerList.find(x => x.questionId === waiverQuestions[1].id).answer"></v-textarea>
                                    <v-flex class="answer-text" v-if="isPrintForm"> {{waiverDetails.waiverAnswerList.find(x => x.questionId === waiverQuestions[1].id).answer}}
                                    </v-flex>
                            </v-flex>
                            <v-flex class="form-control" v-if="waiverDetails.typeOfWaiver === waiverFormConstants.AGE_TYPE">
                                <v-flex tag="span">{{waiverQuestions[2].question}}
                                    <v-flex tag="small" class="error-color">{{waiverFormConstants.MANDATORY}}</v-flex>
                                </v-flex>
                                <v-textarea
                                    v-if="!isPrintForm"
                                    auto-grow
                                    solo
                                    data-qe-id="txt_form_waiver_age_q1"
                                    :readonly="disableWaiverDetails(waiverDetails)"
                                    :rules="validationRules.question_Rule"
                                    v-model="waiverDetails.waiverAnswerList.find(x => x.questionId === waiverQuestions[2].id).answer"></v-textarea>
                                    <v-flex class="answer-text" v-if="isPrintForm"> {{waiverDetails.waiverAnswerList.find(x => x.questionId === waiverQuestions[2].id).answer}}
                                    </v-flex>
                            </v-flex>
                            <v-flex v-if="waiverDetails.typeOfWaiver === waiverFormConstants.TITLE_TYPE">
                                <v-flex class="form-control">
                                    <v-flex tag="span">{{waiverQuestions[3].question}}
                                        <v-flex tag="small" class="error-color">{{waiverFormConstants.MANDATORY}}</v-flex>
                                    </v-flex>
                                    <v-textarea
                                        v-if="!isPrintForm"
                                        auto-grow
                                        solo
                                        data-qe-id="txt_form_waiver_title_q1"
                                        :readonly="disableWaiverDetails(waiverDetails)"
                                        :rules="validationRules.question_Rule"
                                        v-model="waiverDetails.waiverAnswerList.find(x => x.questionId === waiverQuestions[3].id).answer"></v-textarea>
                                        <v-flex class="answer-text" v-if="isPrintForm"> {{waiverDetails.waiverAnswerList.find(x => x.questionId === waiverQuestions[3].id).answer}}
                                        </v-flex>
                                </v-flex>
                                <v-flex class="form-control">
                                    <v-flex tag="span">{{waiverQuestions[4].question}}
                                        <v-flex tag="small" class="error-color">{{waiverFormConstants.MANDATORY}}</v-flex>
                                    </v-flex>
                                    <v-textarea
                                        v-if="!isPrintForm"
                                        auto-grow
                                        solo
                                        data-qe-id="txt_form_waiver_title_q2"
                                        :readonly="disableWaiverDetails(waiverDetails)"
                                        :rules="validationRules.question_Rule"
                                        v-model="waiverDetails.waiverAnswerList.find(x => x.questionId === waiverQuestions[4].id).answer"></v-textarea>
                                        <v-flex class="answer-text" v-if="isPrintForm"> {{waiverDetails.waiverAnswerList.find(x => x.questionId === waiverQuestions[4].id).answer}}
                                        </v-flex>
                                </v-flex>
                                <v-flex class="form-control">
                                    <v-flex tag="span">{{waiverQuestions[5].question}}</v-flex>
                                    <v-textarea
                                        v-if="!isPrintForm"
                                        auto-grow
                                        solo
                                        data-qe-id="txt_form_waiver_title_q3"
                                        :readonly="disableWaiverDetails(waiverDetails)"
                                        v-model="waiverDetails.waiverAnswerList.find(x => x.questionId === waiverQuestions[5].id).answer"></v-textarea>
                                        <v-flex class="answer-text" v-if="isPrintForm"> {{waiverDetails.waiverAnswerList.find(x => x.questionId === waiverQuestions[5].id).answer}}
                                        </v-flex>
                                </v-flex>
                                <v-flex class="form-control">
                                    <v-flex tag="span">{{waiverQuestions[6].question}}</v-flex>
                                    <v-textarea
                                        v-if="!isPrintForm"
                                        auto-grow
                                        solo
                                        data-qe-id="txt_form_waiver_title_q4"
                                        :readonly="disableWaiverDetails(waiverDetails)"
                                        v-model="waiverDetails.waiverAnswerList.find(x => x.questionId === waiverQuestions[6].id).answer"></v-textarea>
                                        <v-flex class="answer-text" v-if="isPrintForm"> {{waiverDetails.waiverAnswerList.find(x => x.questionId === waiverQuestions[6].id).answer}}
                                        </v-flex>
                                </v-flex>
                                <v-flex class="form-control">
                                    <v-flex tag="span">{{waiverQuestions[7].question}}
                                        <v-flex tag="small" class="error-color">{{waiverFormConstants.MANDATORY}}</v-flex>
                                    </v-flex>
                                    <v-textarea
                                        v-if="!isPrintForm"
                                        auto-grow
                                        solo
                                        data-qe-id="txt_form_waiver_title_q5"
                                        :readonly="disableWaiverDetails(waiverDetails)"
                                        :rules="validationRules.question_Rule"
                                        v-model="waiverDetails.waiverAnswerList.find(x => x.questionId === waiverQuestions[7].id).answer"></v-textarea>
                                        <v-flex class="answer-text" v-if="isPrintForm"> {{waiverDetails.waiverAnswerList.find(x => x.questionId === waiverQuestions[7].id).answer}}
                                        </v-flex>
                                </v-flex>
                            </v-flex>
                        </v-flex>
                        <v-flex class="form-control">
                            <v-flex tag="span">{{waiverFormConstants.FORM_QUESTION3}} </v-flex>
                            <v-textarea
                                v-if="!isPrintForm"
                                auto-grow
                                solo
                                data-qe-id="txt_form_waiver_q3"
                                :readonly="disableWaiverDetails(waiverDetails)"
                                v-model="waiverDetails.additionalComments"></v-textarea>
                                <v-flex class="answer-text" v-if="isPrintForm"> {{waiverDetails.additionalComments}}
                                </v-flex>
                        </v-flex>
                        <v-layout row wrap>
                            <v-flex class="form-control" v-if="waiverDetails.typeOfWaiver === waiverFormConstants.TITLE_TYPE">
                                <v-flex
                                    font-italic
                                    tag="span"
                                    class="mandatory_title">{{waiverFormConstants.FORM_QUESTION4}}</v-flex>
                            </v-flex>
                            <v-flex xs12 class="attach-documents">
                                <file-attachment
                                    v-if="waiverDetails"
                                    :leadId="localProspect.id"
                                    :maxFilesToAttach="appCommonConstants.MAXIMUM_NUMBER_OF_FILE_ATTACHMENTS_WAIVER"
                                    :maxFileSizeLimit="appCommonConstants.FILE_ATTACHMENT_SIZE_LIMIT"
                                    :attachments="waiverDetails.attachments"
                                    :viewType="chapterWaiverConstants.CHAPTEROFFICER"
                                    :showAttachRequired="showAttachRequired"
                                    :attachmentCallback="handleAttachedFiles"
                                    :disabled="disableWaiverDetails(waiverDetails)">
                                </file-attachment>
                            </v-flex>
                            <v-flex
                                text-xs-right
                                xs12
                                v-if="showSaveAsDraftButton(waiverDetails) && reportVisible">
                                <v-flex tag="span"
                                    class="failure-message"
                                    text-xs-center
                                    v-if="saveDraftValidation(waiverDetails)">
                                    {{chapterWaiverConstants.DRAFT_ERROR}}
                                </v-flex>
                                <v-btn
                                    v-if="!isPrintForm && !showPrint"
                                    data-qe-id="btn_save"
                                    class="primary_btn mr-0"
                                    @click="saveAsDraft(waiverDetails, false)"
                                    :disabled="isSaveButtonDisabled">
                                    {{chapterWaiverConstants.SAVE_AS_DRAFT}}
                                </v-btn>
                                <v-btn
                                    v-if="!isPrintForm && !showPrint"
                                    data-qe-id="btn_save"
                                    class="primary_btn mr-0"
                                    @click="saveAsDraft(waiverDetails, true)">
                                    {{chapterWaiverConstants.SAVE_AS_PDF}}
                                </v-btn>
                                <v-btn
                                    v-if="showPrint"
                                    data-qe-id="btn_save"
                                    class="primary_btn mr-0"
                                    @click="printForm(waiverDetails)">
                                    {{chapterWaiverConstants.SAVE_AS_PDF}}
                                </v-btn>
                            </v-flex>
                            <v-flex
                                mr-2
                                text-xs-right
                                class="prospective-member__list-item__save-info"
                                v-if="isDraft">{{saveMessage}}</v-flex>
                        </v-layout>
                    </v-form>
                    <WaiverComments v-if="waiverDetails && waiverDetails.waiverCommentList && waiverDetails.waiverCommentList.length > 0" :waiverCommentList="waiverDetails.waiverCommentList"></WaiverComments>
                    <v-progress-linear
                        indeterminate
                        v-show="saveWaiverDetails && saveWaiverDetails.pending"
                        class="ma-2"></v-progress-linear>
                    <v-flex
                        xs12
                        class="failure-message"
                        v-if="isErrorDraft">
                        {{errorWaiverMessage}}
                    </v-flex>
                </v-flex>
            </v-flex>
        </v-layout>
    </div>
</template>

<script>
    import { appCommonConstants, routerNames } from "../appCommon.constants";
    import { chapterWaiverConstants, waiverFormConstants, validationRules, printForm } from "./ChapterWaiver.constants";
    import { mapState, mapGetters, mapMutations, mapActions } from "vuex";
    import { storeAction } from "../../store/storeActions.constant";
    import { storeGetters } from "../../store/storeGetters.constant";
    import { storeMutation } from "../../store/storeMutations.constant";
    import { imageErrorFallback, getCommaSeparatedValue, removeCommas } from "../../common/utils/utils";
    import { waiverStatusConstants, mappedWaiverStatusConstants } from "../ChapterPage/ChapterAdminView/ChapterAdminConstants";
    import FileAttachment from "../ChapterWaiver/FileAttachments";
    import StatusBar from "../StatusBar/StatusBar";
    import { getFormattedDate, getFormattedDateUTC } from "../../common/utils/dateTime";
    import WaiverComments from "./WaiverComments";
    import { VProgressLinear } from 'vuetify/es5/components/VProgressLinear';
    import moment from 'moment/src/moment';
    import { isNullOrUndefined } from 'util';
    import isEmpty from 'lodash/isEmpty';

    export default {
        name: "WaiverForm",
        components: {
            FileAttachment,
            StatusBar,
            WaiverComments,
            VProgressLinear,
        },
        data: () => {
            return {
                waiverStatusConstants,
                mappedWaiverStatusConstants,
                appCommonConstants,
                chapterWaiverConstants,
                waiverFormConstants,
                validationRules,
                getInProgress: false,
                isSave: false,
                valid: true,
                isDraft: false,
                isError: false,
                errorMessage: '',
                imageErrorFallback,
                requestedMessage: chapterWaiverConstants.WAIVER_REQUESTED_MESSAGE,
                saveMessage: chapterWaiverConstants.WAIVER_SAVED_MESSAGE,
                isErrorDraft: false,
                errorWaiverMessage: chapterWaiverConstants.WAIVER_ERROR_MESSAGE,
                reportVisible: true,
                datePickerMenu: false,
                menu: false,
                dobChanged: false,
                getCommaSeparatedValue,
                removeCommas,
                showPrint: false,
                routerNames,
                localProspect: {},
            };
        },
        created() {
            this.$watch(() => {
                this.localProspect = this.$props.prospect;
            });
            if (this.isPrintForm) {
                this.localProspect = this.printWaiverDetails;
            }
            this.setWaiverStatus(this.localProspect);
        },
        mounted() {
            if (this.isPrintForm) {
                this.toggleWaiver(this.localProspect.id);
            }
        },
        watch: {
            valid() {
                this.valid = this.valid && !this.showAttachRequired;
            },
        },
        methods: {
            ...mapActions({
                getWaiverDetails: `chapterWaiver/${storeAction.getWaiverDetails}`,
                submitWaiverRequest: `chapterWaiver/${storeAction.submitWaiverRequest}`,
                saveWaiverRequest: `chapterWaiver/${storeAction.saveWaiverRequest}`,
            }),
            ...mapMutations({
                setVisibleProspect: `chapterWaiver/${storeMutation.setVisibleProspect}`,
                setWaiverDetails: `chapterWaiver/${storeMutation.setWaiverDetails}`,
                setCompleteWaiverDetails: `chapterWaiver/${storeMutation.setCompleteWaiverDetails}`,
                setPrintWaiverDetails: `chapterWaiver/${storeMutation.setPrintWaiverDetails}`,
            }),
            isFormValid() {
                let isValid = false;
                const [ref] = Object.keys(this.$refs).map((key) => {
                    return this.$refs[key];
                });
                if (ref) {
                    isValid = ref.validate();
                }
                return isValid;
            },
            toggleWaiver(leadId) {
                if (this.isWaiverVisible) {
                    this.setVisibleProspect(null);
                } else {
                    const viewType = this.chapterWaiverConstants.CHAPTEROFFICER;
                    const req = {
                        leadId,
                        viewType,
                    };
                     if (this.communityIdFromRoute) {
                        req.communityId = this.communityIdFromRoute;
                    }
                    this.getInProgress = true;
                    this.getWaiverDetails(req).then(() => {
                        this.getInProgress = false;
                        if (this.$route && this.$route.name === this.routerNames.WAIVER_FORM) {
                            setTimeout(() => {
                                this.$nextTick(() => {
                                    this.showPrint = true;
                                    this.printForm(this.localProspect);
                                });
                            }, 1000);
                        }
                    });
                    this.setVisibleProspect(this.sequence);
                    this.isError = false;
                }
            },
            getRequestedDate(prospect) {
                if (prospect.waiverDecisionDate != null) {
                    return this.getFormattedDate(prospect.waiverDecisionDate);
                } else if (prospect.waiverRequestedDate !== null && prospect.waiverStatus === this.mappedWaiverStatusConstants.REQUESTED) {
                    return this.getFormattedDate(prospect.waiverRequestedDate);
                }
                return this.getFormattedDate(prospect.waiverRequestedDate);
            },
            userName() {
                return `${this.localProspect.firstName} ${this.localProspect.lastName}`;
            },
            setWaiverStatus(prospect) {
                if (prospect.waiverStatus === this.waiverStatusConstants.DENIED) {
                    prospect.waiverStatus = this.mappedWaiverStatusConstants.DENIED;
                } else if (prospect.waiverStatus === this.waiverStatusConstants.APPROVED) {
                    prospect.waiverStatus = this.mappedWaiverStatusConstants.APPROVED;
                } else if (prospect.waiverStatus === this.waiverStatusConstants.PENDING) {
                    prospect.waiverStatus = this.mappedWaiverStatusConstants.PENDING;
                } else if (prospect.waiverStatus === this.waiverStatusConstants.REQUESTED) {
                    prospect.waiverStatus = this.mappedWaiverStatusConstants.REQUESTED;
                }
            },
            setColor(waiverStatus) {
                if (waiverStatus === this.mappedWaiverStatusConstants.DENIED) {
                    return 'color-red';
                } else if (waiverStatus === this.mappedWaiverStatusConstants.APPROVED) {
                    return 'color-green';
                } else if (waiverStatus === this.waiverStatusConstants.PENDING) {
                    return 'color-black';
                } else if (waiverStatus === this.waiverStatusConstants.REQUESTED) {
                    return 'color-black';
                }
            },
            submitWaiver(waiverDetails) {
                this.isError = false;
                this.errorMessage = this.chapterWaiverConstants.ERROR_MESSAGE;
                if (waiverDetails && waiverDetails.id === this.localProspect.id) {
                    if (!this.isWaiverVisible && this.checkWaiverDetails(waiverDetails)) {
                        this.isError = true;
                        setTimeout(() => { this.errorMessage = ''; }, this.chapterWaiverConstants.MAX_TIMEOUT);
                    } else if (this.isWaiverVisible) {
                        const [ref] = Object.keys(this.$refs).map((key) => {
                            return this.$refs[key];
                        });
                        if (this.isFormValid() && !this.showAttachRequired) {
                            const postBody = {
                                ...waiverDetails,
                            };
                            postBody.viewType = this.chapterWaiverConstants.CHAPTEROFFICER;
                            this.submitWaiverRequest(postBody).then(() => {
                                this.isSave = true;
                                this.setVisibleProspect(null);
                                setTimeout(() => { this.requestedMessage = ''; }, this.chapterWaiverConstants.MAX_TIMEOUT);
                            });
                        }
                    } else {
                        const postBody = {
                            ...waiverDetails,
                        };
                        postBody.viewType = this.chapterWaiverConstants.CHAPTEROFFICER;
                        this.submitWaiverRequest(postBody).then(() => {
                            this.isSave = true;
                            this.setVisibleProspect(null);
                            setTimeout(() => { this.requestedMessage = ''; }, this.chapterWaiverConstants.MAX_TIMEOUT);
                        });
                    }
                } else if (this.checkWaiverDetails(this.localProspect)) {
                    this.isError = true;
                    setTimeout(() => { this.errorMessage = ''; }, this.chapterWaiverConstants.MAX_TIMEOUT);
                } else {
                    const postBody = {
                        ...this.localProspect,
                    };
                    postBody.viewType = this.chapterWaiverConstants.CHAPTEROFFICER;
                    this.submitWaiverRequest(postBody).then(() => {
                        this.isSave = true;
                        this.setVisibleProspect(null);
                        setTimeout(() => { this.requestedMessage = ''; }, this.chapterWaiverConstants.MAX_TIMEOUT);
                    });
                }
            },
            fixNullValues(waiverDetails) {
                if (isNullOrUndefined(waiverDetails.numberOfEmployees) || isEmpty(waiverDetails.numberOfEmployees)) {
                    waiverDetails.numberOfEmployees = this.prospect.numberOfEmployees;
                } else if (isNullOrUndefined(waiverDetails.chapterMembersCount) || isEmpty(waiverDetails.chapterMembersCount)) {
                    waiverDetails.chapterMembersCount = this.prospect.chapterMembersCount;
                }
                return waiverDetails;
            },
            saveAsDraft(waiverDetails, isSaveAsPDF) {
                waiverDetails = this.fixNullValues(waiverDetails);
                const postBody = {
                    ...waiverDetails,
                };
                postBody.viewType = this.chapterWaiverConstants.CHAPTEROFFICER;
                postBody.isDraft = true;
                this.saveWaiverRequest(postBody).then(() => {
                        this.isDraft = true;
                        if (this.isDraft) {
                            this.saveMessage = this.chapterWaiverConstants.WAIVER_SAVED_MESSAGE;
                            setTimeout(() => { this.saveMessage = ''; }, this.chapterWaiverConstants.MAX_TIMEOUT);
                        }
                        if (this.dobChanged) {
                            waiverDetails.age = moment().diff(waiverDetails.birthdate, 'years');
                        }
                        if (isSaveAsPDF) {
                            this.saveAsPDF();
                        }
                        setTimeout(() => { this.saveMessage = ''; }, this.chapterWaiverConstants.MAX_TIMEOUT);
                    })
                    .catch(() => {
                        this.isErrorDraft = true;
                        if (this.isErrorDraft) {
                            this.errorWaiverMessage = this.chapterWaiverConstants.WAIVER_ERROR_MESSAGE;
                            setTimeout(() => {
                                this.errorWaiverMessage = '';
                                this.isErrorDraft = false;
                            }, this.chapterWaiverConstants.MAX_TIMEOUT);
                        }
                        if (isSaveAsPDF) {
                            this.saveAsPDF();
                        }
                    });
            },
            disableSubmitButton(prospect) {
                return this.isSave || this.checkResubmitWaiver(prospect) || this.showPrint;
            },
            checkResubmitWaiver(prospect) {
                return prospect.waiverFlowStatus !== this.chapterWaiverConstants.RESUBMIT && (prospect.waiverStatus === this.mappedWaiverStatusConstants.REQUESTED || prospect.waiverStatus === this.waiverStatusConstants.REQUESTED);
            },
            disableWaiverDetails(waiverDetails) {
                return this.showPrint || this.isSave || this.checkResubmitWaiver(waiverDetails) ||
                    waiverDetails.waiverStatus === this.waiverStatusConstants.PENDING ||
                    waiverDetails.waiverStatus === this.mappedWaiverStatusConstants.PENDING ||
                    waiverDetails.waiverStatus === this.waiverStatusConstants.DENIED ||
                    waiverDetails.waiverStatus === this.mappedWaiverStatusConstants.DENIED ||
                    waiverDetails.waiverStatus === this.waiverStatusConstants.APPROVED ||
                    waiverDetails.waiverStatus === this.mappedWaiverStatusConstants.APPROVED;
            },
            showSaveAsDraftButton(waiverDetails) {
                return !this.checkResubmitWaiver(waiverDetails) &&
                    waiverDetails.waiverStatus !== this.waiverStatusConstants.PENDING &&
                    waiverDetails.waiverStatus !== this.mappedWaiverStatusConstants.PENDING &&
                    waiverDetails.waiverStatus !== this.waiverStatusConstants.DENIED &&
                    waiverDetails.waiverStatus !== this.mappedWaiverStatusConstants.DENIED &&
                    waiverDetails.waiverStatus !== this.waiverStatusConstants.APPROVED &&
                    waiverDetails.waiverStatus !== this.mappedWaiverStatusConstants.APPROVED;
            },
            handleAttachedFiles(attachedFiles) {
                if (attachedFiles) {
                    this.valid = this.isFormValid() && !this.showAttachRequired;
                }
            },
            datePickerAction() {
                this.menu = false;
                this.dobChanged = true;
            },
            checkWaiverDetails(waiverDetails) {
                return waiverDetails.typeOfWaiver === null || waiverDetails.typeOfCompany === null ||
                    waiverDetails.companyName === null || waiverDetails.title === null ||
                    waiverDetails.numberOfEmployees === null || waiverDetails.totalCompensation === null ||
                    waiverDetails.age === null || waiverDetails.companyWebsite === null ||
                    waiverDetails.companyName === '' || waiverDetails.title === '' ||
                    waiverDetails.numberOfEmployees === '' || waiverDetails.totalCompensation === '' ||
                    waiverDetails.age === '' || waiverDetails.companyWebsite === '' ||
                    waiverDetails.enterpriseValue === null || !waiverDetails.birthdate ||
                    !waiverDetails.corporationType || waiverDetails.dollarVolume === null ||
                    waiverDetails.chapterMembersCount === null || waiverDetails.dollarVolume === '' ||
                    waiverDetails.chapterMembersCount === '' || waiverDetails.enterpriseValue === '' ||
                    (waiverDetails.typeOfWaiver === 'Title' && (!waiverDetails.waiverAnswerList.length ||
                        waiverDetails.waiverAnswerList.findIndex(wa => (wa.waiverType === waiverDetails.typeOfWaiver || !wa.waiverType) &&
                            wa.questionId !== 6 && wa.questionId !== 7 && wa.answer === '') > -1)) ||
                    (waiverDetails.typeOfWaiver !== 'Title' && (!waiverDetails.waiverAnswerList.length ||
                        waiverDetails.waiverAnswerList.findIndex(wa => (wa.waiverType === waiverDetails.typeOfWaiver || !wa.waiverType) && wa.answer === '') > -1)) ||
                    (waiverDetails.title.toLowerCase() === 'other' && (!waiverDetails.titleOther || waiverDetails.titleOther === ''));
            },
            getFormattedDate,
            getFormattedDateUTC,
            selectOtherTitle(waiverDetails) {
                waiverDetails.titleOther = null;
            },
            saveDraftValidation(waiverDetails) {
                const waiverFormID = `waiverDetails-${waiverDetails.id}`;
                const formDetails = this.$refs[waiverFormID];
                let isInvalid = false;
                if (formDetails && formDetails.$children && formDetails.$children.length > 0) {
                    formDetails.$children.forEach((formcontrol) => {
                        if (!isInvalid) {
                            isInvalid = formcontrol && formcontrol.errorBucket && formcontrol.errorBucket[0] && formcontrol.errorBucket[0].length && formcontrol.errorBucket[0].includes("valid");
                        } else {
                            return isInvalid;
                        }
                    });
                }
                return isInvalid;
            },
            saveAsPDF() {
                this.setPrintWaiverDetails(this.localProspect);
                this.$router.push('/waiverForm');
            },
            printForm,
        },
        computed: {
            ...mapState("actionState", ["actions"]),
            ...mapGetters({
                visibleProspect: `chapterWaiver/${storeGetters.visibleProspect}`,
                waiverQuestions: `chapterWaiver/${storeGetters.waiverQuestions}`,
                waiverDetails: `chapterWaiver/${storeGetters.waiverDetails}`,
                completeWaiverDetails: `chapterWaiver/${storeGetters.completeWaiverDetails}`,
                companyTypes: `chapterWaiver/${storeGetters.companyTypes}`,
                corporationTypes: `chapterWaiver/${storeGetters.corporationTypes}`,
                waiverTypes: `chapterWaiver/${storeGetters.waiverTypes}`,
                titleTypes: `chapterWaiver/${storeGetters.titleTypes}`,
                printWaiverDetails: `chapterWaiver/${storeGetters.printWaiverDetails}`,
            }),
            isWaiverVisible() {
                return this.visibleProspect === this.sequence;
            },
            showSubmitButton() {
                return this.localProspect.waiverStatus !== this.mappedWaiverStatusConstants.PENDING &&
                    this.localProspect.waiverStatus !== this.mappedWaiverStatusConstants.DENIED &&
                    this.localProspect.waiverStatus !== this.mappedWaiverStatusConstants.APPROVED;
            },
            submitWaiverDetails() {
                return this.actions[storeAction.submitWaiverRequest];
            },
            showAttachRequired() {
                const attchRequired = this.waiverDetails && this.waiverDetails.typeOfWaiver === this.waiverFormConstants.TITLE_TYPE && (!this.waiverDetails.attachments || this.waiverDetails.attachments.length < 1);
                // eslint-disable-next-line vue/no-side-effects-in-computed-properties
                this.valid = this.isFormValid() && !attchRequired;
                return attchRequired;
            },
            saveWaiverDetails() {
                return this.actions[storeAction.saveWaiverRequest];
            },
            isSaveButtonDisabled() {
            const isTitleOtherSelected = this.waiverDetails.title && this.waiverDetails.title.toLowerCase() === this.waiverFormConstants.OTHER;
            const isTitleOtherEmpty = !this.waiverDetails.titleOther;
            return this.saveDraftValidation(this.waiverDetails) || (isTitleOtherSelected && isTitleOtherEmpty);
            },
            computedDateFormatted() {
                if (this.birthDateISOString) {
                    return this.getFormattedDateUTC(this.birthDateISOString);
                }
                return "";
            },
            birthDateISOString: {
                get() {
                    return new Date(this.waiverDetails.birthdate).toISOString().substr(0, 10);
                },
                set(date) {
                    this.waiverDetails.birthdate = moment.utc(date);
                },
            },
            isPrintForm() {
                return this.$route && this.$route.name === this.routerNames.WAIVER_FORM;
            },
            communityIdFromRoute() {
              return this.$route.params.communityId;
            },
        },
        props: {
            prospect: {
                type: Object,
                required: false,
            },
            sequence: {
                type: Number,
                required: false,
            },
        },
    };
</script>

<style lang="scss" scoped>
    @import "../../common/styles/_colors.scss";
    @import "../../common/styles/responsive.scss";

    .color-red {
        color: $ypo-deep-red;
    }

    .color-green {
        color: $ypo-waiver-status-green;
    }

    .color-black {
        color: $black;
    }

    .prospective-member {
        &__list-item {
            border-bottom: 1px solid $ypo-tile-border;
            align-items: center;
            padding: 10px 15px;

            &__view {
                font-weight: bold;

                span {
                    display: block;
                    color: $ypo-gray-text;
                    font-family: Raleway, serif;
                }

                i {
                    color: $ypo-cta;
                    cursor: pointer;
                }
            }

            .success-text {
                color: $ypo-green;
            }

            .failure-text {
                color: $ypo-red;
            }

            &__sent-info {
                padding-right: 10px;

                @include breakpoint(sm) {
                    display: inherit;
                }

                @include breakpoint(xs) {
                    display: inline-block;
                }
            }

            &__status {
                @include breakpoint(xs) {
                    padding-left: 0 !important;
                }
            }
        }

        .view-wavier {
            background-color: rgba($ypo-blue-grey, 0.3);
            border-radius: 4px;
            box-shadow: 0 1px 3px 0 rgba($black, 0.2);
            border: 1px solid rgba($ypo-blue-grey, 0.8);
            opacity: 0;
            overflow: hidden;
            height: 0;
            transition: all 0.5s;

            &.active {
                height: auto;
                opacity: 1;
            }

            h1 {
                text-align: center;
                font-weight: 500;
                font-family: Raleway, serif;
                font-size: 22px;
                padding-left: 0;
                color: $ypo-blue;
                margin-bottom: 12px;

                span {
                    color: $ypo-red;
                }
            }

            h2 {
                padding-left: 0;
                border-bottom: 0;
                margin-bottom: 12px;
            }

            .form-control {
                span {
                    color: $ypo-cta;
                    display: block;
                }

                small {
                    color: $ypo-cta;
                    font-size: 12px;
                }

                em {
                    font-size: 12px;
                }

                .error-color {
                    color: $ypo-error-red;
                    font-weight: bold;
                }

                .fa-info-circle {
                    cursor: pointer;
                }
            }

            .attach-documents {
                span {
                    color: $ypo-cta;
                    font-size: 14px;
                    text-align: center;
                    padding: 8px 20px;
                    border: 1px $ypo-cta dashed;
                    font-weight: 600;
                    cursor: pointer;
                    display: inline-block;
                    transition: 0.3s all ease;

                    &:hover {
                        background-color: $ypo-cta;
                        color: $white;
                    }

                    i {
                        margin-right: 10px;
                    }
                }
            }
        }
    }

    .save-pdf-link {
        font-weight: bold;
        font-style: italic;
        cursor: pointer;
    }
    .answer-text {
        border-radius: 5px;
        border: 2px solid $ypo-blue-grey;  
        padding: 10px 10px 10px 10px;
    }
</style><style lang="scss">
    @import "../../common/styles/_colors.scss";

    .prospective-member {
        &__list-item {
            &__user {
                .theme--light.v-list {
                    background: transparent;
                }

                .v-list__tile {
                    padding: 0;
                    height: auto;
                }

                .v-list__tile__title {
                    font-weight: bold;
                    color: $ypo-cta;
                }

                .v-list__tile__sub-title {
                    font-weight: 500;
                    color: $ypo-blue !important;
                    font-family: Raleway, serif;
                    font-size: 12px;
                }
            }
        }

        .view-wavier {
            .form-control {
                .v-input {
                    margin-top: 10px;
                }

                .v-input__control {
                    min-height: inherit;
                }

                .v-input__slot {
                    background: transparent !important;
                    box-shadow: none !important;
                    padding-left: 0 !important;

                    &:before {
                        border-color: rgba($black, 0.2);
                    }
                }

                input {
                    border-bottom: 1px solid rgba($black, 0.2);
                }

                .v-select__slot {
                    input {
                        border-bottom: 0;
                    }
                }

                .v-label,
                input {
                    font-size: 14px;
                    font-weight: bold;
                    color: $ypo-gray-text !important;
                }

                .v-textarea {
                    .v-input__slot {
                        border: 1px solid rgba($black, 0.2);
                        padding-left: 10px !important;
                        border-radius: 4px;
                        font-size: 14px;
                        color: $ypo-gray-text !important;
                    }
                }

                &.link {

                    .v-label,
                    input {
                        color: $ypo-cta !important;
                    }
                }

                .v-menu__content {
                    box-shadow: 0 2px 5px 0 rgba($black, 0.18);
                    border: 1.5px solid rgba($ypo-text-border, 0.25);
                    border-radius: 3px;

                    .v-list {
                        background: $ypo-extra-light-gray;

                        &>div {
                            &:hover {
                                background: $ypo-cta;

                                .v-list__tile__title {
                                    color: $white;
                                }
                            }

                            .v-list__tile__title {
                                font-size: 16px;
                            }
                        }
                    }
                }

                .date-of-birth {
                    input {
                        border-bottom: 0;
                    }

                    .v-input__slot {
                        border-bottom: 1px solid rgba($black, 0.2);
                    }
                }
            }

            .failure-message {
                color: $ypo-deep-red;
                margin: 8px;
                text-align: center;
            }
        }
    }
</style>
